var collapsible_list_component_rtlignore_default = {
  "ltr": "MFJkA",
  "rtl": "_5RWUp",
  "iconContainer": "-Xz3b",
  "icon": "uGf8D",
  "isExpanded": "_9JgoH",
  "listDimensions": "-IDbe"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
